import React, { Component, Suspense } from 'react'
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import Cookies from 'js-cookie'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const ForgotPassLink = React.lazy(() => import('./views/pages/forgotPassLink/ForgotPassLink'))

const isAuthenticated = Cookies.get('isAuthenticated');

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/login" name="Login Page" element={!isAuthenticated ? <Login /> : <Navigate to="/" replace />} />
            <Route exact path="/resetlink" name="Login Page" element={<ForgotPassLink />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="*" name="Home" element={isAuthenticated ? <DefaultLayout /> : <Navigate to="login" replace />} />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
